import { render } from "./transferencia.vue?vue&type=template&id=416c50f6&scoped=true"
import script from "./transferencia.vue?vue&type=script&lang=js"
export * from "./transferencia.vue?vue&type=script&lang=js"

import "./transferencia.vue?vue&type=style&index=0&id=416c50f6&lang=scss&scoped=true"
import "./transferencia.vue?vue&type=style&index=1&id=416c50f6&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416c50f6"]])

export default __exports__